import * as $ from 'jquery';

var SelectAttached = function($select)
{
    var attached_id = $select.data('attached-to'),
        $attached = $('select#' + attached_id),
        hide = ($select.data('hide')) ? $select.data('hide') : false;

    console.log(hide);

    // Find the select this is attached to
    if ($attached.length > 0)
    {
        var attach_changed_function = function(e) {
            var $attached_select = $(this),
                $selected = $attached_select.find('option:selected'),
                $all_select_options = $select.find('option');

            // Disable all options for the original select
            if (hide)
            {
                $all_select_options.hide();
            } else
            {
                $all_select_options.prop('disabled', true);
            }

            // Loop through currently selected options in the attached select
            $selected.each(function() {
                var items = $(this).data('attach-data');

                if (items)
                {
                    // Loop through all the items of the select we need to filter
                    $all_select_options.each(function() {
                        var $this = $(this),
                            val = parseInt($this.val());

                        // Check if the val we need to check
                        if ($this.data('filter-value')) val = $this.data('filter-value');

                        if (items.indexOf(val) !== -1)
                        {
                            if (hide)
                            {
                                $this.show();
                            } else
                            {
                                $this.prop('disabled', false);
                            }
                        } else
                        {
                            $this.prop('selected', false);
                        }
                    });
                }
            });

            // Reset the select's bootstrap-select
            $select.selectpicker('refresh');
        };
        // If we found the select it is attached to
        $attached.on('change', attach_changed_function);

        // Run right now.
        attach_changed_function.call($attached);
    }
};

export default SelectAttached;